<template lang="pug">
  .container-fluid
    nuxt
</template>
<script>
export default {
  name: 'Login',
};
</script>
